export class LoginRequestDto {
  userName?: any;
  password?: any;
  rememberMe?: boolean;
}
